import script from "./base-line-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-line-detail.vue?vue&type=script&setup=true&lang=ts"

import "./base-line-detail.vue?vue&type=style&index=0&id=8d82685a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d82685a"]])

export default __exports__